/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FieldError } from "react-hook-form";
import { FlexContainer, SVGIconProps, Text, theme } from "@nordcloud/gnui";
import { IconBoxSelector } from "../../components";

export enum Provider {
  AWS = "AWS",
  AZURE_EA = "AZURE_EA",
  GCP = "GCP",
}

type ProviderConfigValue = {
  icon: SVGIconProps["name"];
  label: string;
};

type ProviderConfig = {
  [key in Provider]?: ProviderConfigValue;
};

type Props = {
  selected: Provider | null;
  onSelect: (provider: Provider) => void;
  providerConfig: ProviderConfig;
  error?: FieldError;
};

export function ProviderSelector({
  selected,
  onSelect,
  error,
  providerConfig,
}: Props) {
  const selectorItems = Object.entries(providerConfig).map(([key, value]) => ({
    id: key as Provider,
    iconName: value?.icon ?? "default",
    title: value?.label ?? "",
  }));

  const hasError = error != null;

  return (
    <>
      <FlexContainer
        gap={theme.spacing.spacing05}
        paddingTop={theme.spacing.spacing04}
        paddingBottom={theme.spacing.spacing08}
        css={{
          width: "100%",
        }}
      >
        <IconBoxSelector
          items={selectorItems}
          selected={selected}
          customCss={{ justifyContent: "center" }}
          onSelect={onSelect}
        />
      </FlexContainer>
      {hasError && (
        <Text mt={theme.spacing.spacing01} color="danger">
          {error?.message}
        </Text>
      )}
    </>
  );
}
